import axios from 'axios';

const API_URL = `${process.env.REACT_APP_API_URL}`;

const getAuthHeaders = () => {
  const token = localStorage.getItem('accessToken');
  return {
    headers: {
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/json',
    },
  };
};

const getAuthHeadersMultipart = () => {
  const token = localStorage.getItem('accessToken');
  return {
    headers: {
      Authorization: `Bearer ${token}`,
      'Content-Type': 'multipart/form-data',
    },
  };
};

// POST /api/v1/blogs/upload-image
export const uploadBlogImage = async (file, onProgress) => {
  try {
    const formData = new FormData();
    formData.append('image', file);

    const response = await axios.post(`${API_URL}blogs/upload-image`, formData, {
      ...getAuthHeadersMultipart(),
      onUploadProgress: (progressEvent) => {
        const percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total);
        if (onProgress) {
          onProgress(percentCompleted);
        }
      },
    });
    return response.data;
  } catch (error) {
    throw error.response?.data || error;
  }
};

// GET /api/v1/blogs
export const getBlogs = async (page = 1, limit = 10) => {
  try {
    const response = await axios.get(`${API_URL}blogs`, {
      ...getAuthHeaders(),
      params: { page, limit },
    });
    return response.data;
  } catch (error) {
    throw error.response?.data || error;
  }
};

// GET /api/v1/blogs/:id  (preview a single blog as the user would see it)
export const getBlogPreview = async (id) => {
  try {
    const response = await axios.get(`${API_URL}blogs/${id}`, getAuthHeaders());
    return response.data;
  } catch (error) {
    throw error.response?.data || error;
  }
};

// GET /api/v1/blogs/admin/list?page=1&limit=10
export const getAdminBlogs = async (page = 1, limit = 10) => {
  try {
    const response = await axios.get(`${API_URL}blogs/admin/list`, {
      ...getAuthHeaders(),
      params: { page, limit },
    });
    return response.data;
  } catch (error) {
    throw error.response?.data || error;
  }
};

// GET /api/v1/blogs/:id
export const getBlogById = async (id) => {
  try {
    const response = await axios.get(`${API_URL}blogs/${id}`, getAuthHeaders());
    return response.data;
  } catch (error) {
    throw error.response?.data || error;
  }
};

// POST /api/v1/blogs
export const createBlog = async (blogData) => {
  try {
    const response = await axios.post(`${API_URL}blogs`, blogData, getAuthHeaders());
    return response.data;
  } catch (error) {
    throw error.response?.data || error;
  }
};

// PUT /api/v1/blogs/:id
export const updateBlog = async (id, blogData) => {
  try {
    const response = await axios.patch(`${API_URL}blogs/${id}`, blogData, getAuthHeaders());
    return response.data;
  } catch (error) {
    throw error.response?.data || error;
  }
};

// DELETE /api/v1/blogs/:id
export const deleteBlog = async (id) => {
  try {
    const response = await axios.delete(`${API_URL}blogs/${id}`, getAuthHeaders());
    return response.data;
  } catch (error) {
    throw error.response?.data || error;
  }
};
